/**
 * Akce pro nekonečný scroll - klientský.
 */
import storeFromArea from "./../../utils/storeFromArea";
import getSetFromIdsList from "../../utils/getSetFromIdsList";

export const REQUEST = 'list.infinite.request';
export const RESPONSE = 'list.infinite.response';
export const RELOAD = 'list.infinite.reload';
export const FILTER = 'list.infinite.filter';
export const REMOVE = 'list.infinite.remove';
export const INVALIDATE = 'list.infinite.invalidate';
export const CHANGES = 'list.infinite.changes';
export const SELECT_PARENT = 'list.infinite.selectParent';
export const LOAD_MORE_REQUEST = 'list.infinite.loadMore.request';
export const LOAD_MORE_RESPONSE = 'list.infinite.loadMore.response';
export const CHECKING_MY_IDS_REQUEST = 'list.infinite.checkingMyIds.request';
export const CHECKING_MY_IDS_RESPONSE = 'list.infinite.checkingMyIds.response';
export const UPDATED_REQUEST = 'list.infinite.updated.request';
export const UPDATED_META_REQUEST  = 'list.infinite.updated.meta.request';
export const UPDATED_RESPONSE = 'list.infinite.updated.response';
export const UPDATED_META_RESPONSE = 'list.infinite.updated.meta.response';

/**
 * Zneplatnění dat.
 * @param area oblast
 */
export function invalidate(area) {
    return {
        type: INVALIDATE,
        area,
    }
}

/**
 * Aktualizace některých dat v načteném seznamu řádků - jedná se o ruční aktualizaci některých položek seznamu - např. jeden objekt ze seznamu chceme aktualizovat.
 * @param area oblast
 * @param rows seznam objektů po atualizaci, pokud bude obsahovat objekt s id ještě nenačteného objektu v seznamu, nic se nestane
 */
export function updateRows(area, rows) {
    return {
        type: UPDATED_RESPONSE,
        area,
        rows
    }
}

/**
 * Aktualizace některých dat v načteném seznamu řádků - jedná se o ruční aktualizaci některých položek seznamu - např. jeden objekt ze seznamu chceme aktualizovat.
 * @param area oblast
 * @param rows seznam objektů po atualizaci, pokud bude obsahovat objekt s id ještě nenačteného objektu v seznamu, nic se nestane
 */
export function updateMeta(area, rows) {
    return {
        type: UPDATED_META_RESPONSE,
        area,
        rows
    }
}

/**
 * Zneplatnění dat.
 * @param area oblast
 * @param updatedIds seznam id entit, které byly upraveny
 * @param createdIds seznam id entit, které byly vytvořeny
 * @param deletedIds seznam id entit, které smazány
 * @param removeDeleted true, pokud má odebrat smazané ze seznamu
 * @return {*}
 */
export function changes(area, updatedIds, createdIds, deletedIds, removeDeleted) {
    return {
        type: CHANGES,
        area,
        updatedIds,
        createdIds,
        deletedIds,
        removeDeleted
    }
}

/**
 * Další donačtení dat.
 * @param area oblast
 * @param getRowsByIds, promis načtení seznamu objektů na základě seznamu id, předpis: (ids) => {}
 * @return {{type: string, area: *}}
 */
export function loadMore(area, getRowsByIds) {
    return (dispatch, getState) => {
        let store = storeFromArea(getState(), area);
        if (!store.isFetching && !store.loadingMore) {   // aktuálně nenačítá data ani more
            const ids = store.allIds.slice(store.rows.length, store.rows.length + store.loadMoreCount);

            // Začínáme načítat data
            dispatch({
                type: LOAD_MORE_REQUEST,
                area,
            });

            // Načtení dat
            getRowsByIds(ids)
                .then(rows => {
                    let newStore = storeFromArea(getState(), area);
                    if (newStore.loadingMore) { // nic se nezměnilo, promítneme načtená data
                        dispatch(loadMoreResponse(area, rows, ids));
                    }
                });
        }
    };
}

function loadMoreResponse(area, rows, requiredIds) {
    return {
        type: LOAD_MORE_RESPONSE,
        area,
        rows,
        requiredIds
    };
}

/**
 * Filtrování položek seznamu.
 * @param area oblast
 * @param filter filtr
 * @param resetData pokud je true, resetují se načtená data při aplikování filtru - fetched bude false a data nebudou načtena
 * @returns {{type: string, area: *, filter: *}}
 */
export function filter(area, filter, resetData = false) {
    return {
        type: FILTER,
        area,
        filter,
        resetData
    }
}

export function remove(area, ids) {
    return {
        type: REMOVE,
        area,
        ids,
    };
}

function parseAllIdsData(data) {
    if (Array.isArray(data)) {
        return { ids: data, allMetaMap: null };
    } else {
        let ids;
        if (data.allIds) {
            ids = data.allIds;
        } else {
            ids = Object.keys(data.allMetaMap);
        }
        return {
            ids,
            allMetaMap: data.allMetaMap
        }
    }
}

export function checkMyIds(area, getAllIds) {
    return (dispatch, getState) => {
        let store = storeFromArea(getState(), area);
        if (store.addedIds.length > 0 && !store.checkingMyIds && !store.hasNewIds) {
            dispatch({
                area,
                type: CHECKING_MY_IDS_REQUEST
            });

            getAllIds(store.parent, store.filter, false)
                .then(data => {
                    let newStore = storeFromArea(getState(), area);
                    if (newStore.checkingMyIds) {   // pořád platí
                        const {ids} = parseAllIdsData(data);

                        const addedIdsMap = getSetFromIdsList(newStore.addedIds);  // bereme aktuální seznam id, mohl se změnit
                        let hasNewIds = false;
                        for (let a=0; a<ids.length; a++) {
                            if (addedIdsMap[ids[a]]) {  // bylo přidáno a měl by ho vidět
                                hasNewIds = true;
                                break;
                            }
                        }
                        dispatch({
                            area,
                            type: CHECKING_MY_IDS_RESPONSE,
                            hasNewIds
                        });
                    }
                })  // TODO [stanekpa] - řešit catch a vrácení datakey!
                .catch(error => {
                    // dispatch(invalidate(area))   // zatím ne, protože se to poté opakuje pořád dokola, nutné řešit opakování s prodlevou a po několika neúspěšných pokusem ukončit
                })
        }
    }
}

export function reload(area, parent, getAllIds, getRowsByIds) {
    return (dispatch, getState) => {
        let store = storeFromArea(getState(), area);

        if (!store.isFetching && store.parent === parent) {    // jen pokud již nenačítá seznam id
            const dataKey = store.getDataKey.bind(store)();
            dispatch(request(area, dataKey));

            // Načtení seznamu id
            getAllIds(store.parent, store.filter, true)
                .then(data => {
                    const {ids, allMetaMap} = parseAllIdsData(data);

                    // Donačtení objektů k idčkůmy - jen k tolika, kolik jsme jich předtím zobrazovali
                    const requiredIds = ids.slice(0, store.rows.length);
                    callGetRowsByIds(getRowsByIds, requiredIds)
                        .then(rows => {
                            dispatch(reloadData(area, ids, requiredIds, rows, allMetaMap));
                        });
                })  // TODO [stanekpa] - řešit catch a vrácení datakey!
                .catch(error => {
                    // dispatch(invalidate(area))   // zatím ne, protože se to poté opakuje pořád dokola, nutné řešit opakování s prodlevou a po několika neúspěšných pokusem ukončit
                })
        }
    }
}

function reloadData(area, ids, requiredIds, rows, allMetaMap) {
    return {
        area,
        type: RELOAD,
        ids,
        requiredIds,
        rows,
        allMetaMap
    };
}

function callGetRowsByIds(getRowsByIds, ids) {
    if (ids.length > 0) {
        return getRowsByIds(ids);
    } else {
        return Promise.resolve([]);
    }
}

/**
 * Načtení dat pokud je potřeba.
 * @param area oblast
 * @param parent parent data pro seznam, pokud je potřeba, např. id nadřazené entity, ke které se vztahuje seznam
 * @param getAllIds promise pro načtení seznamu všech id odpovídajích filtru, předpis: (parent, filter) => {}
 * @param getRowsByIds, promis načtení seznamu objektů na základě seznamu id, předpis: (ids) => {}
 * @param forceFetch pokud je true, provede se vždy nové načtení
 */
export function fetchIfNeeded(area, parent, getAllIds, getRowsByIds, forceFetch = false) {
    return (dispatch, getState) => {

        // Spočtení data key
        let store = storeFromArea(getState(), area);

        // Pokud ve store není potřebný parent, dáme ho tam, aby se nám správně spočetl data key
        if (store.parent !== parent) {
            dispatch(selectParent(area, parent));
            store = storeFromArea(getState(), area);
        }

        const dataKey = store.getDataKey.bind(store)();
        if (forceFetch || store.currentDataKey !== dataKey) {
            dispatch(request(area, dataKey));

            // Vstupní data pro request dat
            const storeForRequest = storeFromArea(getState(), area);
            const filter = storeForRequest.filter;

            getAllIds(parent, filter, true)
                .then(data => {
                    const newStore = storeFromArea(getState(), area);
                    const newDataKey = newStore.getDataKey.bind(newStore)();
                    if (newDataKey === dataKey) {   // jen pokud přídchozí objekt odpovídá datům, které chceme ve store
                        const {ids, allMetaMap} = parseAllIdsData(data);
                        dispatch(response(area, ids, 0, allMetaMap))
                    }
                })  // TODO [stanekpa] - řešit catch a vrácení datakey!
                .catch(error => {
                    // dispatch(invalidate(area))   // zatím ne, protože se to poté opakuje pořád dokola, nutné řešit opakování s prodlevou a po několika neúspěšných pokusem ukončit
                })
        } else {    // pokud máme nějaké objekty k aktualizaci, provedeme ji
            // Objekty
            const needUpdateIds = Object.keys(store.needUpdateIds);
            if (needUpdateIds.length > 0) { // provedeme aktualizaci těchto dat
                dispatch({
                    type: UPDATED_REQUEST,
                    area
                });

                callGetRowsByIds(getRowsByIds, needUpdateIds, false)
                    .then(rows => {
                        dispatch(updateRows(area, rows));
                    });
            }

            // Meta k objektům
            if (store.allMetaMap) {
                const needUpdateMetaIds = Object.keys(store.needUpdateMetaIds);
                if (needUpdateMetaIds.length > 0) { // provedeme aktualizaci těchto dat
                    dispatch({
                        type: UPDATED_META_REQUEST,
                        area
                    });

                    callGetRowsByIds(getRowsByIds, needUpdateIds, true)
                        .then(rows => {
                            dispatch(updateMeta(area, rows));
                        });
                }
            }
        }
    }
}

/**
 * Test, předaná akce je akcí pro tuto třídu.
 * @param action akce
 * @returns {boolean} true, pokud action odpovídá této třídě
 */
export function is(action) {
    switch (action.type) {
        case FILTER:
        case REQUEST:
        case RESPONSE:
        case INVALIDATE:
            return true;
        default:
            return false;
    }
}

/**
 * Výběr nového parenta, volá se i v případě, že je zavoláno fetchIfNeeded s jiným parent něž ve store.
 * @param area oblast
 * @param id id
 * @returns {{type: string, area: *, id: *}}
 */
function selectParent(area, parent) {
    return {
        type: SELECT_PARENT,
        area,
        parent,
    }
}

/**
 * Request dat.
 * @param area oblast
 * @param dataKey data key
 * @returns {{type: string, area: *, dataKey: *}}
 */
function request(area, dataKey) {
    return {
        type: REQUEST,
        area,
        dataKey,
    }
}

/**
 * Response dat.
 * @param area oblast
 * @param rows řádky
 * @param count celkový počet řádek, např. v db pro daný filter
 * @param allMetaMap mapa meta ke všem řádkům
 * @returns {{type: string, area: *, data: *}}
 */
function response(area, rows, count, allMetaMap) {
    return {
        type: RESPONSE,
        area,
        rows,
        count,
        allMetaMap
    }
}

